export default __webpack_public_path__ + "static/media/fotball.f4e52dd6.jpg";